// Helpers Index
// Re-exports all helper functions

export {
  extractMetadataFields,
  createFaqComponent,
  updateFaqComponent,
  createVisionariesComponent,
  updateVisionariesComponent,
  createLearnFromLeadersComponent,
  updateLearnFromLeadersComponent,
  createProgramStructureComponent,
  updateProgramStructureComponent,
  createProgramCardsComponent,
  updateProgramCardsComponent,
  createElectiveComponent,
  updateElectiveComponent,
  createFooterComponent,
  updateFooterComponent,
} from "./sectionHelpers";

